export enum SubscriptionStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  CONFIRMATION = 'confirmation',
}
